import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=471b3c9c&scoped=true&"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js&"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=471b3c9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b3c9c",
  null
  
)

export default component.exports